import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import styles from "../../subscription.module.scss";
import Switch from "@mui/material/Switch";

const OptInOptOut = ({ optInOptOutData, SaveOptInOptOutDeatils }) => {
  const [defaultSelectedOption, setDefaultSelectedOption] = useState([]); // default selected option from api
  const [isPrivateView, setIsPrivateView] = useState(null);        // to check the toggle button of switch
  const [isDefaultPrivateView, setIsDefaultPrivateView] = useState(true); // saving the default value of toggle button of the switch
  const [selectedOptIn, setSelectedOptIn] = useState([]);  // will store the selected option by the user
  const resultData = "OPTOUT";

  // save function
  const handleSaveOption = () => {
    // Convert the array to a string
    const optionsString = selectedOptIn?.join(",");
    // console.log("isprivate",isPrivateView)
    // console.log("selectedOptIn",selectedOptIn)

    if (isPrivateView) {
      // console.log(resultData);
      SaveOptInOptOutDeatils(resultData);
    } else {
      // console.log(optionsString);
      SaveOptInOptOutDeatils(optionsString);
    }
  };

  // to compare 1 arrays for save and clear button (defaultSelectedOption and selectedOptIn)
  function compareArrayValues(arr1, arr2) {
    const filteredArr1 = arr1?.filter(
      (value, index, self) => self?.indexOf(value) === index
    );
    const filteredArr2 = arr2?.filter(
      (value, index, self) => self?.indexOf(value) === index
    );
    return (
      filteredArr1?.length === filteredArr2?.length &&
      filteredArr1?.every((value) => filteredArr2?.includes(value))
    );
  }

  useEffect(() => {
    // console.log("optInOptOutData:", optInOptOutData);
    const getOptIn = optInOptOutData?.split(",");
    if (optInOptOutData?.includes("OPTOUT")) {
      setIsPrivateView(true);
      setIsDefaultPrivateView(true);
      setDefaultSelectedOption(getOptIn);
      setSelectedOptIn(getOptIn);
    } else {
      setSelectedOptIn(getOptIn);
      setDefaultSelectedOption(getOptIn);
      setIsPrivateView(false);
      setIsDefaultPrivateView(false);
    }
    if (!optInOptOutData) {
      setSelectedOptIn(["YEARLY"]);
      setDefaultSelectedOption([]);
      setIsPrivateView(false);
      setIsDefaultPrivateView(false);
    }
  }, [optInOptOutData]);

  return (
    <div className="details-box my-4">
      <Container fluid>
        <Row className="py-3">
          <Col xs={12}>
            <h3>Configure Renewed Subscriptions Notification</h3>
          </Col>
        </Row>
        {/* {optInOptOutData ? 
        ( */}

        <>
          <div
            className={`${styles["content"]} ${styles["opt-in-out"]} mb-4 py-3`}
          >
            <span>
              <span className="text-strong">Opt-OUT </span>
              <Switch
                checked={!isPrivateView}
                onChange={() => {
                  // console.log(isPrivateView)
                  setIsPrivateView(!isPrivateView);
                  if (!isPrivateView) setSelectedOptIn(["OPTOUT"]);
                  else setSelectedOptIn([]);
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
              <span className="text-strong">Opt-IN </span>
            </span>
            {!isPrivateView && (
              <Row>
                <Form className="my-2">
                  {["checkbox"].map((type) => (
                    <div key={`default-${type}`} className="mb-2">
                      <Form.Check
                        type={type}
                        id={`default-yearly-${type}`}
                        label={"Yearly Renewals"}
                        checked={selectedOptIn?.includes("YEARLY")}
                        onClick={() => {
                          if (
                            selectedOptIn?.includes("YEARLY") &&
                            !selectedOptIn?.includes("MONTHLY")
                          ) {
                            setSelectedOptIn([]);
                          } else {
                            setSelectedOptIn((prev) =>
                              prev?.includes("YEARLY")
                                ? prev?.filter((option) => option !== "YEARLY")
                                : [...prev, "YEARLY"]
                            );
                          }
                        }}
                      />

                      <Form.Check
                        type={type}
                        id={`default-monthly-${type}`}
                        label={"Monthly Renewals"}
                        checked={selectedOptIn?.includes("MONTHLY")}
                        onClick={() => {
                          if (
                            selectedOptIn?.includes("MONTHLY") &&
                            !selectedOptIn?.includes("YEARLY")
                          ) {
                            setSelectedOptIn([]);
                          } else {
                            setSelectedOptIn((prev) =>
                              prev?.includes("MONTHLY")
                                ? prev?.filter((option) => option !== "MONTHLY")
                                : [...prev, "MONTHLY"]
                            );
                          }
                        }}
                      />
                    </div>
                  ))}
                </Form>

                <h4 className="text-muted text-bold my-2">
                  Note: You have the flexibility to select either Yearly
                  Renewals or Monthly Renewals or both
                </h4>
              </Row>
            )}
          </div>
          <div className="d-flex justify-content-end py-3">
            {compareArrayValues(defaultSelectedOption, selectedOptIn) ===
            false ? (
              <Button
                variant="light"
                className="mr-3 px-4 btn-border-light w-md-auto col-xs-12"
                onClick={() => {
                  setSelectedOptIn(defaultSelectedOption);
                  setIsPrivateView(isDefaultPrivateView);
                }}
              >
                Clear
              </Button>
            ) : (
              <Button
                variant="light"
                className="mr-3 px-4 btn-border-light w-md-auto col-xs-12"
                disabled
              >
                Clear
              </Button>
            )}

            {compareArrayValues(defaultSelectedOption, selectedOptIn) ===
              true || selectedOptIn?.length === 0 ? (
              <Button
                variant="light"
                className="mr-1 px-4 btn-border-light w-md-auto col-xs-12"
                disabled
              >
                Save
              </Button>
            ) : (
              <Button
                className="mr-1 px-4 col-xs-12"
                onClick={handleSaveOption}
              >
                Save
              </Button>
            )}
          </div>
        </>

        {/* if empty state is required use this */}
        {/* ) : (
          <div
            className={`${styles["content"]} ${styles["opt-in-out"]} mb-4 py-3`}
          >
            <p>No Data Found.</p>
          </div>
        )} */}
      </Container>
    </div>
  );
};

export default OptInOptOut;
